<template>
  <div class="animated fadeIn">
    <b-card no-header>
      <b-form>
        <!-- <label>Opciones del Sorteo</label> -->
        <b-form-group
          :label-cols="labelCols"
          horizontal>
          <b-form-checkbox 
              id="soloClientes"
              v-model="soloClientes"
              value= true
              unchecked-value= false>
              Sólo clientes de DIRECTV
          </b-form-checkbox>
        </b-form-group>

        <b-form-group
          :label-cols="labelCols"
          horizontal>
          <b-form-checkbox 
              id="dobleChanceClientes"
              v-model="dobleChanceClientes"
              value= true
              unchecked-value= false>
              Doble chance para clientes de DIRECTV
          </b-form-checkbox>
        </b-form-group>
      </b-form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="sortear">Sortear</b-button>
        <b-button size="sm" variant="primary" class="footer-button" 
          @click.prevent="close">Cancelar</b-button>
      </div>
    </b-card>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
// import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';

export default {
  name: 'Sorteo',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    eventoId: {
      type: Number,
      default: 0
    },
    sorteoGlobalId: {
      type: Number,
      default: 0
    },
  },
  data: () => {
    return {
      labelCols: 0,

      soloClientes: false,
      dobleChanceClientes: false,
    }
  },
  // computed: {
  //   opcionesDTV () {
  //     return false;
  //   }
  // },
  created() {
  },  
  methods: {
    sortear() {
      let params = {
        eventoId: this.eventoId,
        sorteoGlobalId: this.sorteoGlobalId,
        soloClientes: this.soloClientes,
        dobleChanceClientes: this.dobleChanceClientes
      }

      this.showSpinner();
      this.$store.dispatch('sorteo/sortear', params)
        .then(()  => this.showModalMsj('El sorteo se completó éxito.', this.closeSorteado, this.closeSorteado, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    closeSorteado() {
      this.$emit('close', true)
    },
    close() {
      this.$emit('close', false)
    },
  },
}
</script>